import { render, staticRenderFns } from "./QuestIdentity.vue?vue&type=template&id=66a7fae4&scoped=true&"
import script from "./QuestIdentity.ts?vue&type=script&lang=ts&"
export * from "./QuestIdentity.ts?vue&type=script&lang=ts&"
import style0 from "./QuestIdentity.scss?vue&type=style&index=0&id=66a7fae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7fae4",
  null
  
)

export default component.exports